var _path, _circle, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0049 2.86924H12.2413C8.99057 2.86924 2.43836 4.94636 2.23572 13.2548V70.5022H46.5645V50.491M68.9821 50.491C64.4226 50.2883 62.8605 46.3536 62.6495 44.4116V25.0336M68.9821 50.491C71.093 50.7021 75.5175 49.7817 76.328 44.4116V25.0336H62.6495M68.9821 50.491H46.5645M62.6495 25.0336V9.70854C62.6495 4.13579 58.2166 1.60352 54.2903 1.60352C49.0975 1.60352 46.3111 6.543 46.5645 9.70854V50.491",
    stroke: "#48576D",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5327,
    cy: 62.5165,
    r: 11.7851,
    fill: "#1F2A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7225 62.5165C43.4685 58.3975 50.8371 52.6308 58.3429 62.5165C55.635 66.6356 48.3199 72.4024 40.7225 62.5165Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1485 62.5162C63.1485 70.036 57.0525 76.132 49.5327 76.132C42.0129 76.132 35.9169 70.036 35.9169 62.5162C35.9169 54.9964 42.0129 48.9004 49.5327 48.9004C57.0525 48.9004 63.1485 54.9964 63.1485 62.5162ZM37.8546 62.5162C37.8546 68.9658 43.083 74.1943 49.5327 74.1943C55.9824 74.1943 61.2108 68.9658 61.2108 62.5162C61.2108 56.0665 55.9824 50.8381 49.5327 50.8381C43.083 50.8381 37.8546 56.0665 37.8546 62.5162Z",
    fill: "#00A183"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3086 62.516C53.3086 64.6014 51.6181 66.2919 49.5328 66.2919C47.4474 66.2919 45.757 64.6014 45.757 62.516C45.757 60.4307 47.4474 58.7402 49.5328 58.7402C51.6181 58.7402 53.3086 60.4307 53.3086 62.516ZM47.3754 62.516C47.3754 63.7075 48.3413 64.6734 49.5328 64.6734C50.7243 64.6734 51.6902 63.7075 51.6902 62.516C51.6902 61.3245 50.7243 60.3586 49.5328 60.3586C48.3413 60.3586 47.3754 61.3245 47.3754 62.516Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 16.2954,
    width: 32.9299,
    height: 4.55953,
    rx: 2.27976,
    fill: "#00A183"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 33.5205,
    width: 33.6898,
    height: 3.5463,
    rx: 1.77315,
    fill: "#00A183"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 41.626,
    width: 27.1039,
    height: 3.5463,
    rx: 1.77315,
    fill: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 49.7319,
    width: 14.9451,
    height: 3.5463,
    rx: 1.77315,
    fill: "#516077"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 57.8379,
    width: 14.9451,
    height: 3.5463,
    rx: 1.77315,
    fill: "#516077"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7.55518,
    y: 25.4146,
    width: 27.1039,
    height: 3.5463,
    rx: 1.77315,
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListview);
export default __webpack_public_path__ + "static/media/listview.64cd40f9ac46919665bc68db8dc9304b.svg";
export { ForwardRef as ReactComponent };